import { FC, Fragment } from "react";
import { ButtonCell, getSafeAreaInsetBottom } from "~/components";
import clsx from "clsx";
import ICON_LOADING from "~/assets/imgs/icon_loading.png";

interface FooterBtnProps {
    className?: string;
    btnClassName?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    text?: string;
    ifPlaceholder?: boolean;
    btnLoading?: boolean;
    type?: string;
}

export const FooterBtn: FC<FooterBtnProps> = ({
    className = "",
    btnClassName = "",
    style = {},
    onClick = () => {},
    text = "",
    ifPlaceholder = false,
    btnLoading = false,
    type = "default",
}) => {
    return (
        <Fragment>
            {ifPlaceholder && <div style={style} className={className} />}
            <div
                style={{ ...style, bottom: getSafeAreaInsetBottom() }}
                className={clsx(
                    "w-full fixed bottom-0 left-0 px-[16px] bg-bg_bottom",
                    className
                )}
            >
                <ButtonCell
                    className="px-0 block py-0 h-auto overflow-hidden mt-[5px]"
                    onClick={onClick}
                >
                    <div
                        className={clsx(
                            "w-full flex items-center justify-center h-[44px] rounded-[12px] text-h6 font-Semibold",
                            type === "default"
                                ? "bg-bg_0 text-text_1"
                                : "bg-Orange text-white",
                            { "opacity-40": btnLoading },
                            btnClassName
                        )}
                    >
                        <span>{text}</span>
                        {btnLoading && (
                            <img
                                className="loading-rotate-1s w-[24px] h-[24px] absolute right-[12px]"
                                width={24}
                                height={24}
                                src={ICON_LOADING}
                            />
                        )}
                    </div>
                </ButtonCell>
            </div>
        </Fragment>
    );
};
